import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "../../View.jsx";
import ViewUtils from '../../ViewUtils';
import DGDocumentsUploadSearchForm from './DGDocumentUploadsSearchForm'
import EnhancedToolbar from '../../widgets/Toolbar';
import EnhancedTable from '../../widgets/ResponsiveTable';
import DGDocumentUploadsDialog from './DGDocumentUploadsDialog';
import AlertItem from "../../widgets/AlertItem";
import Prompt from '../../widgets/Prompt';
import withMenuPermission from "../../widgets/withMenuPermission";


const utils = new ViewUtils();
const toolbarRef = React.createRef();

const FUNDING_WINDOW_OPEN = "OPEN";
const FUNDING_WINDOW_CLOSED = "CLOSED";
const FUNDING_WINDOW_CLOSED_MESSAGE = "The selected Funding Window is closed";
const FUNDING_WINDOW_NONE_MESSAGE = "There is no Funding Window for the selected Financial Year and Window Type";

const headCells = [
    { id: 'FinancialYear', numeric: false, disablePadding: true, label: 'Financial Year' },
    { id: 'WindowType', numeric: false, disablePadding: true, label: 'Window Type' },
    { id: 'Intervention', numeric: false, disablePadding: true, label: 'Intervention Type' },
    { id: 'DocumentType', numeric: false, disablePadding: true, label: 'Document Type' },
    { id: 'Document', numeric: false, disablePadding: true, label: 'Document', contentType: 'document' },
    { id: 'UploadedBy', numeric: false, disablePadding: true, label: 'Uploaded By' },
    { id: 'UploadDate', numeric: false, disablePadding: true, label: 'Upload Date' }

];

class DGDocumentsUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            model: {},
            addDialogOpen: false,
            selectedDocument: null,
            promptOpen: false,
            promptTitle: "Remove Document",
            promptContent: "Are you sure you want to remove this Document?",
            searchParameters: [
                { Name: "OrganisationID", Value: this.props.location.state.organisationID },
                { Name: "FinancialYearID", Value: 0 },
                { Name: "DGTypeID", Value: 0 },
                { Name: "DGInterventionID", Value: 0 },
                { Name: "DGDocumentTypeID", Value: 0 }
            ],
            FinancialYearID: null,
            DGTypeID: null,
            DGInterventionID: null,
            DGDocumentTypeID: null,
            DocumentDescription: null,
            windowTypeDependency: null,
            interventionDependency: null,
            windowState: null,
            isNonLevyPayer: false,
            toolbarConfig: {
                items: []
            }
        }
    }

    componentDidMount() {
        this.CheckNonLevyPayer();
    }

    getToolbarConfig = () => {
        return {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: "CloseIcon" }
                    ]
                }
                ,
                {
                    type: "devider"
                },

                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Upload Document', disabled: true, icon: 'UploadIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'remove', label: '', tooltip: 'Remove Document', disabled: true, icon: 'DeleteIcon', visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        };
    }

    CheckNonLevyPayer = () => {
        this.setState({ toolbarConfig: this.getToolbarConfig() }, () => {
            let url = "api/sims/DGDocumentUpload/CheckDGOrganisationNonLevyPayer?DGOrganisationID=" + this.props.location.state.organisationID;
            utils.invokeUrl(url, (response) => {
                if (response.Result === "1") {
                    this.setState({ isNonLevyPayer: true, toolbarConfig: this.getToolbarConfig() }, () => {
                        this.updateToolbarState();
                    })
                }
            },
                null,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    }
                }
            )
        });
    }

    isFundingWindowOpen = () => {
        return this.state.windowState === FUNDING_WINDOW_OPEN;
    }

    updateToolbarState = () => {
        if (utils.isNull(toolbarRef.current)) {
            return;
        }

        toolbarRef.current.setButtonDisabled("add", utils.isNull(this.state.DGDocumentTypeID) || !this.isFundingWindowOpen());
        toolbarRef.current.setButtonDisabled("remove", utils.isNull(this.state.selectedDocument) || !this.isFundingWindowOpen());
    }

    checkFundingWindow = (FinancialYearID, DGTypeID) => {
        if (utils.isNull(FinancialYearID) || utils.isNull(DGTypeID)) {
            this.setState({ windowState: null, Message: "", MessageStyle: "" }, () => {
                this.updateToolbarState();
            });

            return;
        }

        let url = "api/sims/DGDocumentUpload/CheckFundingWindow?FinancialYearID=" + FinancialYearID + "&DGTypeID=" + DGTypeID;
        utils.invokeUrl(url, (response) => {
            let message = "";
            let messageStyle = "";

            if (response.Result === FUNDING_WINDOW_CLOSED) {
                message = FUNDING_WINDOW_CLOSED_MESSAGE;
                messageStyle = "warning";
            }
            else if (response.Result !== FUNDING_WINDOW_OPEN) {
                message = FUNDING_WINDOW_NONE_MESSAGE;
                messageStyle = "warning";
            }

            this.setState({ windowState: response.Result, Message: message, MessageStyle: messageStyle }, () => {
                this.updateToolbarState();
            });
        }, () => {
            this.setState({ windowState: null, Message: utils.SYSTEM_ERROR_MESSAGE, MessageStyle: "outlinedError" }, () => {
                this.updateToolbarState();
            });
        },
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        );
    }

    handleToolbarButtonClick = (buttonId) => {
        if (buttonId === "add") {
            this.setState({ addDialogOpen: true });

        } else if (buttonId === "close") {
            this.props.history.push({
                pathname: "/DGOrganisation",
                state: { selection: this.props.location.state.organisationID }
            })
        }
        else if ("remove" === buttonId) {
            this.setState({ promptOpen: true })
        }
    }

    base64ToArrayBuffer = (base64) => {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    getSelectedId = (value) => {
        if (utils.isNull(value) || utils.isNull(value.Id)) {
            return null;
        }

        return value.Id;
    }

    handleFormValueChange(values) {
        if (utils.isNull(values)) {
            return;
        }

        let FinancialYearID = this.getSelectedId(values.FinancialYearID);
        let DGTypeID = utils.isNull(FinancialYearID) ? null : this.getSelectedId(values.DGTypeID);
        let DGInterventionID = utils.isNull(DGTypeID) ? null : this.getSelectedId(values.DGInterventionID);
        let DGDocumentTypeID = utils.isNull(DGInterventionID) ? null : this.getSelectedId(values.DocumentType);
        let DocumentDescription = utils.isNull(DGDocumentTypeID) ? null : values.DocumentType.Description;

        let windowTypeDependency = utils.isNull(FinancialYearID) ? null
            : [{ Name: "FinancialYearID", Value: FinancialYearID }];

        let interventionDependency = (utils.isNull(FinancialYearID) || utils.isNull(DGTypeID)) ? null
            : [{ Name: "FinancialYearID", Value: FinancialYearID }, { Name: "DGTypeID", Value: DGTypeID }];

        let searchParameters = [
            { Name: "OrganisationID", Value: this.props.location.state.organisationID },
            { Name: "FinancialYearID", Value: utils.isNull(FinancialYearID) ? 0 : FinancialYearID },
            { Name: "DGTypeID", Value: utils.isNull(DGTypeID) ? 0 : DGTypeID },
            { Name: "DGInterventionID", Value: utils.isNull(DGInterventionID) ? 0 : DGInterventionID },
            { Name: "DGDocumentTypeID", Value: utils.isNull(DGDocumentTypeID) ? 0 : DGDocumentTypeID }
        ];

        let windowChanged = FinancialYearID !== this.state.FinancialYearID || DGTypeID !== this.state.DGTypeID;

        this.setState({
            searchParameters: JSON.parse(JSON.stringify(searchParameters)),
            model: utils.isNull(values.FinancialYearID) ? {} : { FinancialYearID: values.FinancialYearID },
            FinancialYearID: FinancialYearID,
            DGTypeID: DGTypeID,
            DGInterventionID: DGInterventionID,
            DGDocumentTypeID: DGDocumentTypeID,
            DocumentDescription: DocumentDescription,
            windowTypeDependency: windowTypeDependency,
            interventionDependency: interventionDependency
        }, () => {
            if (windowChanged) {
                this.checkFundingWindow(FinancialYearID, DGTypeID);
            }
            else {
                this.updateToolbarState();
            }
        });
    }

    FileDownload = (rowid, headCell) => {
        if (headCell.contentType === "document") {
            utils.invokeUrl("api/sims/DGDocumentUpload/downloaddocument?id=" + rowid, (response) => {

                var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
                var url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = response.Name;
                link.target = '_blank';
                link.click();
            }, (e) => {
                this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
            }
            );
        }
    };

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedDocument: selection[0].Id }, () => {
                this.updateToolbarState();
            });
        } else {
            this.setState({ selectedDocument: null }, () => {
                this.updateToolbarState();
            });
        }
    }

    postAddHandler(cancel, save, response) {
        if (save === true) {
            if (response.MessageType === "SUCCESS") {
                this.setState({
                    searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                    addDialogOpen: false,
                    selectedDocument: null,
                    Message: response.Message,
                    MessageStyle: "success"
                }, () => {
                    this.updateToolbarState();
                });
            }
            else {
                this.setState({
                    searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                    addDialogOpen: false,
                    selectedDocument: null,
                    Message: response.Message,
                    MessageStyle: "warning"
                }, () => {
                    this.updateToolbarState();
                });
            }
        }
        else if (cancel === true) {
            this.setState({
                addDialogOpen: false,
                selectedDocument: null
            }, () => {
                this.updateToolbarState();
            });
        }
    }


    successfulDocumentRemoveCallback = (response) => {

        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedDocument: null,
                Message: response.Message,
                MessageStyle: response.MessageType.toLowerCase(),
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters))
            }, () => {
                this.updateToolbarState();
            });
        }
    }

    unsuccessfulDocumentRemoveCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({ Message: response.Message, MessageStyle: response.MessageType.toLowerCase() })
        }
    }

    remove(url) {
        this.setState({ promptOpen: false }, () => {
            this.updateToolbarState();
        })

        let fullUrl = `${url}?id=${this.state.selectedDocument}`;
        utils.invokeUrlDelete(fullUrl, this.successfulDocumentRemoveCallback, this.unsuccessfulDocumentRemoveCallback);
    }

    closePrompt = () => {
        this.setState({ promptOpen: false, clearSelectedRow: true, selectedDocument: null }, () => {
            this.updateToolbarState();
        })
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {"DG Organisation > Document Uploads " + (this.props.location.state.organisationName !== null ? "> " + this.props.location.state.organisationName + (this.props.location.state.sdlnumber !== null ? " - " + this.props.location.state.sdlnumber : "") : "> Add")}
                </p>

                <AlertItem message={this.state.Message} alertStyle={this.state.MessageStyle} />

                <div className="searchResults">
                    < DGDocumentsUploadSearchForm
                        windowTypeDependency={this.state.windowTypeDependency}
                        interventionDependency={this.state.interventionDependency}
                        valueChangeHandler={(values) => this.handleFormValueChange(values)}
                    />

                    <EnhancedToolbar highlight={false}
                        title="DG Document Uploads"
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.state.toolbarConfig}
                    />

                    <EnhancedTable
                        headCells={headCells}
                        onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        dataUrl="api/sims/DGDocumentUpload/GetSearch"
                        searchParameters={this.state.searchParameters}
                        onCellSelectionChange={(rowid, headCell) => { this.FileDownload(rowid, headCell) }}
                        paged={true} />
                </div>

                <DGDocumentUploadsDialog
                    open={this.state.addDialogOpen}
                    docType={this.state.DocumentDescription}
                    docID={this.state.DGDocumentTypeID}
                    DGTypeID={this.state.DGTypeID}
                    DGInterventionID={this.state.DGInterventionID}
                    closeHandler={(cancel, save, response) => this.postAddHandler(cancel, save, response)}
                    viewRef={this}
                    OrganisationID={this.props.location.state.organisationID}
                    datamodel={this.state.model}
                />

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => { this.remove("api/sims/DGDocumentUpload/RemoveDGDocument") }}
                    closePrompt={this.closePrompt}
                />

            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(DGDocumentsUpload));
